import { Alert, Box, Button, Modal, ModalProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { BootstrapComp } from "../common/BootstrapComp";

export const CommonContainerModal = (props: {
    child: JSX.Element;
    header: any;
    loading: boolean;
    disabled?: boolean;
    size?: ModalProps.Size;
    onSave: () => void;
    onCancel: () => void;
}) => {
    const [dismissConfirmation, setDismissConfirmation] = React.useState<boolean>();

    const onDismiss = () => {
        setDismissConfirmation(true);
    };

    const LeavingAlertModal = () => {
        return (
            <Modal header="Leave editing" visible={dismissConfirmation} onDismiss={null} footer={
                <Box float="right">
                    <Button variant="link" loading={props.loading} onClick={props.onCancel}>
                        Leave
                    </Button>
                    <Button variant="primary" onClick={() => setDismissConfirmation(false)}>
                        Continue Editing
                    </Button>
                </Box>
            }>
                <Alert type="warning">
                    Are you sure that you want to leave? All changes that you made won't be saved.
                </Alert>
            </Modal>
        );
    };

    return (
        <Modal
            header={props.header}
            visible={true}
            onDismiss={onDismiss}
            size={props.size ? props.size : "medium"}
            footer={
                <Box float="right">
                    <Button variant="link" loading={props.loading} onClick={onDismiss}>
                        Cancel
                    </Button>
                    <Button variant="primary" loading={props.loading} onClick={props.onSave} disabled={props.disabled}>
                        Submit
                    </Button>
                </Box>
            }>
                <LeavingAlertModal/>
                <div>{props.child}</div>
        </Modal>
    );
};

export const CustomCommonContainerModal = (props: {
    child: JSX.Element;
    header: any;
    loading: boolean;
    disabled?: boolean;
    size?: "sm" | "lg" | "xl" | "xxl";
    onSave?: () => void;
    onCancel: () => void;
}) => {
    const [dismissConfirmation, setDismissConfirmation] = React.useState<boolean>();

    const onDismiss = () => {
        setDismissConfirmation(true);
    };

    const LeavingAlertModal = () => {
        return (
            <Modal header="Leave editing" visible={dismissConfirmation} onDismiss={null} footer={
                <Box float="right">
                    <Button variant="link" loading={props.loading} onClick={props.onCancel}>
                        Leave
                    </Button>
                    <Button variant="primary" onClick={() => setDismissConfirmation(false)}>
                        Continue Editing
                    </Button>
                </Box>
            }>
                <Alert type="warning">
                    Are you sure that you want to leave? All changes that you made won't be saved.
                </Alert>
            </Modal>
        );
    };

    return (
        <BootstrapComp.CustomModal
            visible={true}
            size={props.size ? props.size : "xl"}
            header={props.header}
            body={
                <>
                    <LeavingAlertModal/>
                    <div>{props.child}</div>
                </>
            }
            footer={
                <Box float="right">
                    <Button variant="link" loading={props.loading} onClick={onDismiss}>
                        Cancel
                    </Button>
                    {props.onSave && <Button
                        variant="primary"
                        loading={props.loading}
                        onClick={props.onSave}
                        disabled={props.disabled}
                    >
                        Submit
                    </Button>}
                </Box>
            }
            onDismiss={onDismiss}/>
    );
};